export default {
  title: 'Tipos de Serviço',
  description: 'Gerencie os tipos de serviço que aparecerão em seu site.',
  labels: {
    new: 'Novo tipo de serviço',
  },
  form: {
    title: 'Cadastro de tipos de serviço'
  },
  fields: {
    name: 'Tipo de Serviço',
    language: 'Idioma',
    url: 'URL',
    is_active: 'Ativo',
    icon: 'Ícone'
  },
  errors: {
    duplicateCompositeKey: 'Esse tipo de serviço já está cadastrado para este site e idioma.'
  }
}
